export const recruiterTabs = [
  {
    heading: "Account",
    route: "account",
    children: [
      {
        label: "Personal Details",
        route: "personal-details",
      },
      {
        label: "Username",
        route: "username",
      },
      {
        label: "Change Password",
        route: "change-password",
      },
    ],
  },
  {
    heading: "Company",
    route: "company",
    children: [
      {
        label: "Company Details",
        route: "company-details",
      },
      {
        label: "Account Members",
        route: "account-members",
      },
    ],
  },
];

export const candidateTabs = [
  {
    heading: "Account",
    route: "account",
    children: [
      {
        label: "Personal Details",
        route: "personal-details",
      },
      {
        label: "Username",
        route: "username",
      },
      {
        label: "Change Password",
        route: "change-password",
      },
      {
        label: "Referral Member",
        route: "referral-member",
      },
      {
        label: "Privacy",
        route: "privacy",
      },
    ],
  },
];

export const referralTabs = [
  {
    heading: "Account",
    route: "account",
    children: [
      {
        label: "Personal Details",
        route: "personal-details",
      },
      {
        label: "Username",
        route: "username",
      },
      {
        label: "Change Password",
        route: "change-password",
      },
    ],
  },
];

export const hiringCompanyTabs = [
  {
    heading: "Account",
    route: "account",
    children: [
      {
        label: "Personal Details",
        route: "personal-details",
      },
      {
        label: "Username",
        route: "username",
      },
      {
        label: "Change Password",
        route: "change-password",
      },
    ],
  },
  {
    heading: "Company",
    route: "company",
    children: [
      {
        label: "Company Details",
        route: "company-details",
      },
      {
        label: "Account Members",
        route: "account-members",
      },
    ],
  },
];
